import * as React from "react";
import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

export interface PanelEmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  children?: React.ReactNode;
  className?: string;
  compact?: boolean;
}

export function PanelEmptyState({
  icon: Icon,
  title,
  description,
  children,
  className,
  compact = false,
}: PanelEmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center rounded-xl border border-slate-200/90 bg-white text-center shadow-sm",
        compact ? "py-8 px-4" : "py-12 px-4",
        className
      )}
    >
      {Icon ? (
        <Icon className={cn("text-slate-300", compact ? "mb-2 h-8 w-8" : "mb-3 h-10 w-10")} aria-hidden />
      ) : null}
      <p className={cn("m-0 font-medium text-slate-700", compact ? "text-xs" : "text-sm")}>{title}</p>
      {description ? (
        <p
          className={cn(
            "m-0 mt-1 max-w-[280px] text-slate-500",
            compact ? "text-[11px] leading-snug" : "text-xs"
          )}
        >
          {description}
        </p>
      ) : null}
      {children ? <div className={cn("mt-4 flex flex-col items-center gap-2", compact && "mt-3")}>{children}</div> : null}
    </div>
  );
}
